<template>
  <div class="agent-manager" style="display: flex;">
    <!-- Left: List Table -->
    <div style="flex: 4; padding: 24px 0 0px 24px;    background: rgb(101, 101, 101);border-radius: 20px;    margin-right: 10px;    text-align: left;">
      <!-- Search Bar -->
      <div style="display: flex;justify-content: space-between;flex-direction: row;">
        <el-input
          placeholder="输入代理昵称/卡密/备注/提取日期筛选"
          prefix-icon="el-icon-search"
          v-model="search"
          clearable
          class="round-input"
          style="margin-bottom: 12px; width: 360px;"
        />
        <el-date-picker
          v-model="filterDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 280px;margin-right: 20px;"
          @change="handleDateRangeChange"
          clearable
        />
      </div>
      <!-- Table -->
      <el-table
        :data="filteredCards"
        border
        height="calc(100vh - 180px)"
        style="width: 100%; background: rgb(101, 101, 101); color: #fff;"
        @row-click="handleRowClick"
        :row-class-name="tableRowClassName"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="car_mine" label="卡密" sortable>
          <template slot-scope="scope">
            <span
              class="copy-text"
              @click="copyCarMine(scope.row.car_mine)"
              :title="scope.row.car_mine"
            >
              {{ scope.row.car_mine }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="car_mode" label="卡密类型" sortable :filters="cardModeFilters" :filter-method="filterCardMode" filter-placement="bottom-end">
          <template slot-scope="scope">
            {{ getCardModeName(scope.row.car_mode) }}
          </template>
        </el-table-column>
        <el-table-column prop="is_use" label="使用状态" sortable :filters="useStatusFilters" :filter-method="filterUseStatus" filter-placement="bottom-end">
          <template slot-scope="scope">
            {{ getUseStatusName(scope.row.is_use) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="proxy_id"
          label="代理"
          :formatter="formatProxyName">
        </el-table-column>
        <el-table-column prop="create_time" label="提卡时间" sortable></el-table-column>
        <el-table-column prop="receipts" label="实付余额" sortable :sort-method="sortReceipts"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
    </div>

    <!-- Right: Form Panel-->
    <div style="flex: 1; border-radius: 16px;">
      <!-- Add Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-plus"></i> 收益统计
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff; margin-bottom: 16px;">
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="选择时间">
                <el-date-picker
            v-model="querytime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 250px;">
          </el-date-picker>
          </el-form-item>

          <el-form-item label="实付金额">
            <span>{{ editForm.recharge_amount || '请选择查询时间' }}</span>
          </el-form-item>
          <div style="text-align:center;margin-top: 30px;">
            <span>【卡密统计】</span>
            <div class="usage-row" :key="item.car_mode" v-for="item in statistics">
              <span>{{ item.name }}</span>
              <span>{{ item.count }}张</span>
              <span>{{ item.receipts }}元</span>
            </div>
          </div>
          <div>
            <el-button size="small" type="primary" @click="getStatistics" style="margin-left: 12px;">查询统计</el-button>
          </div>
        </el-form>
        <!-- <el-form :model="addForm" label-width="80px">
          <el-form-item label="代理昵称">
            <el-input size="small" v-model="addForm.name" placeholder="请输入代理昵称" />
          </el-form-item>
          <el-form-item label="代理VXID">
            <el-input size="small"  v-model="addForm.vxid" placeholder="请输入代理ID" />
          </el-form-item>
          <el-form-item label="代理类型">
            <el-select size="small"  v-model="addForm.type" placeholder="请选择代理类型">
              <el-option v-for="item in types" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="充值金额">
            <el-input size="small"  v-model="addForm.amount" placeholder="请输入充值金额" />
          </el-form-item>
          
          <el-form-item>
            <el-button size="small"  type="primary" @click="addAgent">确认添加</el-button>
          </el-form-item> -->
        <!-- </el-form> -->
      </el-card>
      <!-- Edit Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-edit"></i> 修改卡密详情
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff;">
        
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="卡密">
            <span
              class="copy-text-right"
              @click="copyCarMine(editForm.car_mine)"
              :title="editForm.car_mine"
            >
              {{ formatCarMine(editForm.car_mine) || '请选择' }}
            </span>
          </el-form-item>
          <el-form-item label="提取时间">
            <span>{{ editForm.create_time || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="卡密状态">
            <span>{{ editForm.is_use || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="实付金额">
            <el-input size="small" v-model="editForm.receipts" placeholder="请输入余额" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input size="small" v-model="editForm.remark" placeholder="请输入余额" />
          </el-form-item>
          
          <div>
            <el-button size="small" type="primary" @click="updateCard" style="margin-left: 12px;">确认修改</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name:"CardPage",
  data() {
    return {
      search: '',
      selectedRowId: null,
      filterDateRange: null, 
      types: ['储值代理', '其他类型'],
      cards: [
        // ...更多数据可参考原型图补充
      ],
      cardprices:[],
      addForm:{},
      querytime:'',
      editForm: {
        name: '',
        vxid: '',
        type: '',
        amount: '',
        expire: ''
      },
      useStatusFilters: [
        { text: '未使用', value: 0 },
        { text: '已使用', value: 1 },
        { text: '已过期', value: 2 },
      ],
      cardModeFilters: [
      ],
      proxys:[],
      useStatus:[
        {
          val:1,
          name:'已使用'
        },
        {
          val:0,
          name:'未使用'
        },
        {
          val:2,
          name:'已过期'
        }
      ],
      statistics:[]
    }
  },
  computed: {
    filteredCards() {
      let filtered = this.cards;

      // 关键词过滤
      if (this.search) {
        const keyword = this.search.toLowerCase().trim();
        filtered = filtered.filter(card => {
          const proxyName = this.formatProxyName(card).toLowerCase();
          const createTime = card.create_time ? String(card.create_time).toLowerCase() : '';
          const carMine = card.car_mine ? card.car_mine.toLowerCase() : '';
          const remark = card.remark ? card.remark.toLowerCase() : '';

          return (
            proxyName.includes(keyword) ||
            carMine.includes(keyword) ||
            remark.includes(keyword) ||
            createTime.includes(keyword)
          );
        });
      }

      // 时间范围过滤
      if (this.filterDateRange && this.filterDateRange.length === 2) {
        const [start, end] = this.filterDateRange;
        const startTime = new Date(start).setHours(0,0,0,0);
        const endTime = new Date(end).setHours(23,59,59,999);

        filtered = filtered.filter(card => {
          if (!card.create_time) return false;
          const cardTime = new Date(card.create_time).getTime();
          return cardTime >= startTime && cardTime <= endTime;
        });
      }

      return filtered;
    }
  },
  methods: {
    formatProxyName(row) {
      const val = row.proxy_id
      if (!val || val === 0) return '超管'
      const proxy = this.proxys.find(p => p.id === val)
      return proxy ? proxy.nick_name : '-'
    },
    sortReceipts(a, b) {
      return Number(a.receipts) - Number(b.receipts);
    },
    handleDateRangeChange(val) {
      // val 是选中的日期范围数组或者null
      // 这里可以直接触发筛选，computed会自动刷新
      console.log('筛选日期范围：', val);
    },
    // 使用状态筛选方法
    filterUseStatus(value, row) {
      return row.is_use === value;
    },
    // 卡密类型筛选方法
    filterCardMode(value, row) {
      return row.car_mode === value;
    },
    async proxyList(){
      try {
        const res = await this.$axios.post('/proxy/list', {
        })
        this.proxys = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    getCardModeName(val) {
      const item = this.cardprices.find(i => i.id === val)
      return item ? item.name : '-'
    },
    getUseStatusName(val) {
      const item = this.useStatus.find(i => i.val === val)
      return item ? item.name : '-'
    },
    formatCarMine(value) {
      if (!value) return '请选择'
      if (value.length <= 20) return value
      return value.slice(0, 20) + '...'
    },
    copyCarMine(text) {
      // 使用原生 API
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(err => {
        console.error(err)
        this.$message.error('复制失败，请手动复制')
      })
    },
    handleRowClick(row) {
      this.selectedRowId = row.id;
      // 选中后把这行数据放到 editForm
      this.editForm = {
        ...row,
        expire: row.expire_time ? new Date(row.expire_time * 1000) : null
      };
    },
    tableRowClassName({ row }) {
      return row.id === this.selectedRowId ? 'selected-row' : '';
    },
    async cardList(){
      try {
        const res = await this.$axios.post('/carmine/list', {
          'search':this.search
        })
        this.cards = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async cardPriceList(){
      try {
        const res = await this.$axios.post('/carmine/cardprice', {
        })
        this.cardprices = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    addAgent() {
      this.agents.push({ ...this.addForm, group: 39 });
      this.$message.success('添加成功');
      this.addForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    async updateCard() {
      try {
        const res = await this.$axios.post('/carmine/update', {
          ...this.editForm
        })
        if(res.code == 200){
          this.cardList();
        }
      } catch (err) {
        console.log(err);
      }
    },
    deleteAgent() {
      this.agents = this.agents.filter(a => a.vxid !== this.editForm.vxid);
      this.$message.success('删除成功');
      this.editForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    async getStatistics(){
      try {
        const res = await this.$axios.post('/carmine/allStatistics', {
          'id':this.editForm.id,
          'querytime':this.querytime
        })
        this.statistics = res.data;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    // 选中左侧表格某行时编辑
    filteredAgents: {
      handler(val) {
        // 可以绑定el-table @row-click事件来填充editForm
        console.log(val)
      }
    }
  },
  async mounted(){
    this.proxyList();
    await this.cardPriceList();
    this.cardModeFilters = this.cardprices.map(i => ({
      text: i.name,
      value: i.id
    }));
    console.log('cardModeFilters',this.cardModeFilters)
    this.cardList()
  }
}
</script>

<style scoped>
::v-deep .el-table .el-table__body-wrapper tbody tr.selected-row > td.el-table__cell {
  background-color: #b0b0b0 !important;
  color: #fff !important;
}
.agent-manager {
  font-family: "PingFang SC", "Helvetica Neue", Arial, "Microsoft YaHei", sans-serif;
}
.el-table th, .el-table td, .el-table tr,el-table__row {
  background: #404040 !important;
  /* color: #000 !important; */
  border-color: #656565 !important;
}
.el-table .el-table__body tr {
  background-color: rgb(101, 101, 101) !important;
}
.el-card {
  border-radius: 12px !important;
  border: none !important;
}
/* .round-input .el-input__inner {
  border-radius: 20px;
} */

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  background-color: rgb(101, 101, 101) !important;
  color: #fff !important;
}

/* 方式 1：v-deep */
::v-deep .el-table,
::v-deep .el-table th,
::v-deep .el-table td {
  border: none !important;
}

/* 如果还有伪元素残留，也可以干掉 */
::v-deep .el-table::before {
  display: none;
}

/* 去掉表头底部分割线 */
::v-deep .el-table__header-wrapper th {
  border-bottom: none !important;
}

/* 去掉表格行的分割线 */
::v-deep .el-table__row td {
  border-bottom: none !important;
}

::v-deep .el-form-item__label {
  color: #fff !important;
}

::v-deep .el-form-item {
    margin-bottom: 0px;
}

/* ::v-deep .el-input--prefix .el-input__inner {
    border-radius: 20px;
} */

.copy-text {
  display: inline-block;
  max-width: 120px; /* 根据你的表格列宽调节 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  color: #409EFF; /* 可以加个蓝色表示可点 */
}

.copy-text:hover {
  text-decoration: underline;
}

.copy-text-right {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  cursor: pointer;
  color: #409EFF;
}

.copy-text-right:hover {
  text-decoration: underline;
}

/* Chrome / Safari / Edge */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2); /* 半透明 */
  border-radius: 4px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

::v-deep .el-table__cell.gutter {
  background: rgb(101, 101, 101) !important;
}

.usage-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 三等分 */
  padding: 6px 0;
  font-size: 12px;
}

.usage-header {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}

</style>